/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "287fb9c80d2957eb066ea7453e9a2656c61669e5";
